import React, { useContext } from 'react';

import cx from 'classnames';
import { useDispatch } from 'react-redux';

import { openUploadModal } from 'components/Layouts/Form/FormBuilder/Content/AddNewContent/uploadModal';
import EditorBlockBar from 'components/shared/EditorBlockBar';
import Image from 'components/shared/Icon/icons/Image';
import NewPDF2 from 'components/shared/Icon/icons/NewPDF2';
import Trash2 from 'components/shared/Icon/icons/Trash2';
import useAssetsPermissions from 'hooks/useAssetsPermissions';

import LandingPageContext from '../../../contexts/LandingPageContext';
import styles from './index.module.css';
import { ISmMenuProps } from './types';

function SmMenu({
  lowerPosition,
  hasFastFactsButton,
  hasImageButton,
  className,
  onDelete,
  onUpdate,
  hasDocumentButton,
  data: block,
}: ISmMenuProps) {
  const dispatch = useDispatch();
  const { page, landingData, isItinerariesItem } = useContext(LandingPageContext);
  const currentPage = isItinerariesItem ? landingData : page;

  const { withAssetSettings } = useAssetsPermissions();

  const getModalTitleText = (type: string) => {
    switch (type) {
      case 'media':
        return 'Replace Photos';
      case 'document':
        return 'Replace PDF';
      default:
        return 'Replace';
    }
  };

  const openModal = async (type: string) => {
    const modalTitle = getModalTitleText(type);
    // @ts-ignore
    const assets = await openUploadModal(dispatch, {
      type,
      suggested: currentPage,
      modalTitle,
      selected: block.data.files,
      isSortingEnabled: true,
      isItinerariesItem,
      withAssetSettings,
      defaults: {
        name: 'name' in currentPage ? currentPage.name : null,
        tags: 'tags' in currentPage ? currentPage.tags : null,
      },
    });

    if (assets === null) {
      return;
    }

    const data = {
      ...block,
      data: {
        ...block.data,
        files: assets,
      },
    };

    onUpdate?.(data);
  };

  const getItems = () => {
    const res = [];

    res.push({ icon: Trash2, className: styles.trashIcon, onClick: onDelete });

    if (hasImageButton) {
      res.unshift({
        icon: Image,
        text: 'Images',
        className: styles.imagesIcon,
        onClick: () => openModal('media'),
        block: true,
      });
    }

    if (hasDocumentButton) {
      res.unshift({
        icon: NewPDF2,
        text: 'PDF',
        className: styles.documentIcon,
        onClick: () => openModal('document'),
        block: true,
      });
    }
    return res;
  };
  const items = getItems();

  if (!items.length) return null;

  return (
    <div className={cx(styles.wrapper, className)}>
      {/*@ts-ignore*/}
      <EditorBlockBar
        className={hasFastFactsButton && styles.trashIconPosition}
        items={items}
        lowerPosition={lowerPosition}
      />
    </div>
  );
}

export default SmMenu;
